import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  CatalogToolbarComponent
} from '~shared/modules/catalog/catalog-products-list/modules/catalog-toolbar/catalog-toolbar.component';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { MmFlexLayoutModule } from '@metromarkets/components';
import { TooltipModule } from '~shared/modules/tooltip/tooltip.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    QaLocatorsModule,
    MmFlexLayoutModule,
    TooltipModule
  ],
  declarations: [
    CatalogToolbarComponent
  ],
  exports: [
    CatalogToolbarComponent
  ],
})
export class CatalogToolbarModule {}
